// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"66":"dfc5e494","281":"d2b94cc7","320":"11b217d1","576":"bce3e8f7","609":"e8d20c33","691":"73c01b1d","702":"9d2f535c","722":"3fb6bff9","758":"0e7343ac","967":"9681ca7f"}[chunkId] + ".chunk.js";
};